// extracted by mini-css-extract-plugin
export default {"basic-panel":"ModalDeleteAdmin_basic-panel__xciza","title":"ModalDeleteAdmin_title__fTkCm","text":"ModalDeleteAdmin_text__+cF9K"};